import { createContext } from 'react';

import { INIT_VALUES_DATA_CONTEXT } from './data.init.values';

export const DataContext = createContext(INIT_VALUES_DATA_CONTEXT);